// reusable components
// ********************************* Package Imports *********************************
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// ********************************* Component Imports ********************************
import Table from "../../components/table/table";
import { CustomButton } from "../../components/buttons/button";
import CommonHeader from "../../components/common-header";

// ********************************* API Imports ********************************

// ********************************* Asset Imports ********************************
import EditIcon from "../../assets/icons/edit.png";
import DeleteIcon from "../../assets/icons/trash.png";

// Current Page Imports
import { FetchUsers } from "../../redux/slices/user.slice";
import { debounce} from "../../utils/redirections";
import { UsersPopup } from "./users-popup";
import { ConfirmPopup } from "../../components/model-popup/confirmation-popup";
import { UsersDeleteAPI } from "../../api/delete";
import { ToggleButton } from "../../components/input-fields/toggle-button";
import { toast } from "react-toastify"
import { Spinner } from "../../components/buttons/spinner";
import { DeleteMultipleUserAPI } from "../../api/delete";
import { getAllRolesList } from "../../api/list";
import {UserPutstatusAPI} from "../../api/update"

// ********************************* inter face  ********************************
import { sortInterFace,ChildProps } from "../../utils/types/interFace";

const UsersPage = ({filteredAccess}:ChildProps) => {
  const dispatch = useDispatch();
  const UsersData = useSelector((state: any) => state?.users || []);
  const userAccess = filteredAccess.length !== 0 ? filteredAccess[0] : {}
  const [roleList, setRoleList] = useState([])
  const [showDeleteModel, setShowDeleteModel] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [limit, ] = useState<number>(15);
  const [search, setSearch] = useState<string>("");
  const [sort, setSort] = useState<sortInterFace>({ created_at: "desc" });
  const [ViewDetails, setViewDetails] = useState<any>({});
  const [loader, setLoader] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modelTitle, setModelTitle] = useState<string>("");
  const [viewPopup, setViewPopup] = useState<boolean>(false);
  const [totalResults, setTotalResults] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  // eslint-disable-next-line
  const handleSearch = useCallback(debounce(setSearch, 500), []);
  const [decrypt, setDecrypt] = useState<any>(null);
  const [statusLoader, ] = useState<any>(null);
  const [showSearch, setShowSearch] = useState<string>(""); // Show search data
  const [emailClipboard, ] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [multiDelete, setMultiDelete] = useState<any>(false);
  const [loginUserDetail, setLoginUserDetail] = useState<any>({})
  
  const handleUsersData = (
    load: boolean,
    sorting: any = {},
    pageNumber?: number
  ) => {
    pageNumber && setPage(pageNumber);
    if (pageNumber || page === 1) {
      setLoader(load);
      setSelectedRows([])
    }
    dispatch(
      FetchUsers({
        page: pageNumber || page,
        limit,
        sort_by:
          Object.keys(sorting).length !== 0
            ? Object.keys(sorting)[0]
            : "created_at",
        sort_dir:
          Object.keys(sorting).length !== 0
            ? sorting[Object.keys(sorting)[0]]
            : "asc",
        search_value: search,
      })
    ).then((res: any) => {
      setTotalResults(res?.payload?.result?.total_pages);
      setTotalCount(res?.payload?.result?.total_count);
      setLoader(false);
    });
  };
  const formatToLocalTime = (utcDate: string) => {
    if (!utcDate) return "-";
    const date = new Date(`${utcDate}Z`);
    return date.toLocaleString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const handleDelete = async () => {
    setButtonLoader(true);
    await UsersDeleteAPI(ViewDetails?.id).then((res: any) => {
      setShowDeleteModel(false);
      if (res?.success) {
        handleSearch([]);
        setShowSearch("");
        // handleUsersData(true, sort);
        setViewDetails({});
        toast.success(res?.message);
      } else {
        toast.error(res?.message || "User delete failed");
      }
      setButtonLoader(false);
    });
  };

  const handleMultiDelete = async () => {
    setButtonLoader(true);
    const selectedIds = selectedRows.map((row: any) => row?.id);
    const users = { user_list: selectedIds };
    await DeleteMultipleUserAPI(users).then(async (res: any) => {
      setShowDeleteModel(false);
      if (res?.success) {
        setViewDetails({});
        setMultiDelete(false);
        setSelectedRows([]);
        toast.success(res?.message);
        if (page === 1) {
          handleUsersData(true, sort);
        } else {
          setPage(1);
        }
      } else {
        toast.error(res?.message || "Users delete failed");
      }
      setButtonLoader(false);
    });
  };

  const getAllRolleList = async () =>{
      await getAllRolesList({}).then(async (res: any) => {
        if (res?.success) {
          setRoleList(res?.result?.data);
        } 
      });
  }
 
  useEffect(() => {
    handleUsersData(true, sort);
  }, [page]);
  
  useEffect(()=>{
    const UserdetailString = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined
    setLoginUserDetail(UserdetailString ? JSON.parse(UserdetailString) : {})
     getAllRolleList()
  },[]);

  useEffect(() => {
    handleSearch(showSearch);
  }, [showSearch]);

  useEffect(() => {
    page === 1 ? handleUsersData(true, sort) : setPage(1);
  }, [limit, search]);

  const handleNextPage = () => {
    setPage(page + 1);
  };

  const handleUpdateStatus = async (e: any, userId: any) => {
    setLoader(true)
    const is_active = e.target.checked
    await UserPutstatusAPI(userId,{is_active:is_active})
    .then((res: any) => {
      if(res?.success){
         page === 1 ? handleUsersData(true, sort) : setPage(1)
         toast.success(res.data?.message || "Update Status successfully")
      } else{
        toast.error(res?.message || res?.detail?.message ||"Update status failed");
      } 
    });
    setLoader(false)
  };

  const showCheckboxCondition = (row:any)=>{
    return !(loginUserDetail?.id === row?.id)
  }

  return (
    <div className="w-full p-[10px] pl-[2px] pr-[2px]">
      <div className="pt-[16px]  pl-[2px] pr-[2px] bg-white rounded-[12px]">
        <CommonHeader
          search
          addNew = {userAccess.write_access}
          heading={"Users"}
          onclickAddButton = {()=>{
            if (roleList && roleList.length <= 0){
              toast.error("There are no active roles in the system. Please create a role before creating a user");
            } else{
              setModelTitle("Add New User");
              setShowModal(true);
            }
          }}
          totalCount={totalCount}
          countForText="Results"
          handleSearch={handleSearch}
          setShowSearch={setShowSearch}
          showSearch={showSearch}
          description="Manage users and control their access rights."
        />
        <Table
          loading={loader}
          showCheckbox={userAccess.delete_access}
          showCheckboxCondition = {showCheckboxCondition}
          setSelectedRows={setSelectedRows}
          MultiDeletedFucn={() => {
            setMultiDelete(true);
            setTimeout(() => {
              setShowDeleteModel(true);
            }, 10);
          }}
          hasNextPage={page < totalResults}
          selectedRows={selectedRows}
          data={UsersData}
          tableScroll={"100%"}
          NextPageData={handleNextPage}
          columns={
            [
              "First Name",
              "Last Name",
              "Email Address",
              "Status",
              "Last Login",
              "Created on",
              ...(userAccess.delete_access || userAccess.update_access ? ["Action"] : [])
            ]
          }
          sort={true}
          columnColSpans={[6, 2, 1, 1, 1, 1]}
          sortTitleKeys={{
            "First Name": "first_name",
            "Last Name": "last_name",
            "Created on": "created_at",
            "Email Address": "email",
            "Last Login": "last_login",
            "Status":"is_active"
          }}
          handleSortfunc={(key: any, value: any) => {
            setSort({ [key]: value });
            page === 1
              ? handleUsersData(false, { [key]: value })
              : handleUsersData(false, { [key]: value }, 1);
          }}
          scopedSlots={{
            "First Name": ({ row }: any) => (
              <td colSpan={6} title={row?.first_name || ""}>
                <div className=" max-w-[500px] truncate ">
                  {row?.first_name || ""}
                </div>
              </td>
            ),
            "Last Name": ({ row }: any) => (
              <td colSpan={1} title={row?.last_name || ""}>
                <div className=" max-w-[500px] truncate ">
                  {row?.last_name || ""}
                </div>
              </td>
            ),
            "Email Address": ({ row }: any) => {
              return (
                <td colSpan={2} title={row?.email}>
                  <div className="inline-flex items-center">
                    <div className="max-w-[140px] truncate ">
                      {row?.email}
                    </div>
                    {userAccess.write_access && (
                      <>
                        {emailClipboard === row?._id ? (
                          <span className="hover:bg-[#308B7E1A] p-[5px] rounded-full text-[#1bc47d]  text-[11px]">
                            &#10003;
                          </span>
                        ) : (
                          <span className="hover:bg-[#308B7E1A] p-[5px] rounded-full">
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </td>
              );
            },

            Status: ({ row, index }: any) => (
              <td colSpan={1}>
                <div className="max-w-[150px] truncate">
                  {statusLoader === row?._id ? (
                    <Spinner
                      classname="w-[20px] h-[20px] ml-[15px] "
                      color="#308B7E"
                    />
                  ) : (
                    <ToggleButton
                      onChange={(e: any) => {
                        if (userAccess.update_access) {
                          handleUpdateStatus(e, row?.id);
                        }
                      }}
                      value={row?.is_active}
                      disabled={!userAccess.update_access || loginUserDetail?.id === row?.id}
                      toggleStyle="w-[36px] h-[20px] after:h-[16px] after:w-[16px] after:top-[2px]"
                    />
                  )}
                </div>
              </td>
            ),
            "Last Login": ({ row }: any) => (
              <td colSpan={1}>
                <div className="max-w-[160px] truncate">
                  {row?.last_login ?formatToLocalTime(row?.last_login) : "-"}
                </div>
              </td>
            ),
            "Created on": ({ row }: any) => (
              <td colSpan={1}>
                <div className="max-w-[150px] truncate ">
                  {row?.created_at ? row?.created_at : ''}
                </div>
              </td>
            ),
            Action: ({ row }: any) => (
              <td colSpan={1} onClick={(e: any) => e.stopPropagation()}>
                {selectedRows?.length > 1 ? null : (
                  <div className="flex gap-[16px] items-center justify-center pr-[4px]">

                   { userAccess.update_access && !(loginUserDetail?.id === row?.id) &&
                      <img
                        src={EditIcon}
                        alt="Edit"
                        className="cursor-pointer w-[18px] h-[18px]"
                        onClick={() => {
                          setViewDetails(row);
                          setModelTitle("Edit User");
                          setShowModal(true);
                        }}
                      />
                    }
                    {
                      userAccess.delete_access && !(loginUserDetail?.id === row?.id) &&
                      <img
                        src={DeleteIcon}
                        onClick={async () => {
                          setShowDeleteModel(true);
                          setViewDetails(row);
                        }}
                        alt="Delete"
                        className="cursor-pointer w-[18px] h-[18px]"
                      />
                    }
                  </div>
                )}
              </td>
            ),
          }}
        />
        {/* <div className="min-h-[50px]">
          {totalResults > 10 && (
            <Pagination
              selectedValue={limit}
              setSelectedValue={setLimit}
              handlePrev={handlePrevPage}
              handleNext={handleNextPage}
              page={page}
              totalPage={UsersData?.totalPage}
              totalResults={totalResults}
              limit={limit}
              currentDataLength={UsersData?.data?.length}
            />
          )}
        </div> */}
        {showModal ? (
          <UsersPopup
            showModal={showModal}
            setShowModal={setShowModal}
            handleClose={() => {
              setViewDetails({});
              setDecrypt("");
              setShowModal(false);
              setViewPopup(false);
            }}
            title={modelTitle}
            setTitle={setModelTitle}
            viewPopup={viewPopup}
            fetchAPI={handleUsersData}
            poupDetails={ViewDetails}
            decryptPassword={decrypt}
            setDecrypt={setDecrypt}
            setPoupDetails={setViewDetails}
            rolesAccess={userAccess}
            roleList={roleList}
          />
        ) : null}
        <ConfirmPopup showModal={showDeleteModel} icon>
          <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
            Delete User?
          </div>
          <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
            You are about to delete{" "}
            <span className="font-semibold">
              {multiDelete
                ? `${selectedRows?.length} users`
                : `“${ViewDetails?.name}”`}
            </span>
            <br />
            Are you sure you want to continue?
          </div>
          <div className="flex justify-center gap-[16px] items-center w-full">
            <CustomButton
              buttonName="No, Keep it"
              primary={false}
              buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              disable={buttonLoader}
              onClick={() => {
                setMultiDelete(false);
                setShowDeleteModel(false);
                setViewDetails({});
              }}
            />
            <CustomButton
              buttonName="Yes, Delete !"
              buttonStyle="w-full text-white bg-[#D41E1E] hover:bg-[#B51C1C] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
              loader={buttonLoader}
              disable={buttonLoader}
              loaderStyle="w-full bg-[#D41E1E]/80  py-[13px] "
              onClick={() => {
                multiDelete ? handleMultiDelete() : handleDelete();
              }}
            />
          </div>
        </ConfirmPopup>
      </div>
    </div>
  );
};

export default UsersPage;